import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { RoleEndPoint } from "../../api-routes";

const createRole = async (data) => {
  return (await axiosInstance.post(RoleEndPoint.CREATE_ROLE, data)).data;
};
const getAllRoles = async (data) => {
  return (await axiosInstance.get(RoleEndPoint.GET_ALL_ROLES)).data;
};

export const useCreateRole = () => {
  return useMutation({
    mutationFn: (data) => createRole(data),
  });
};

export const useGetAllRoles = () => {
  return useQuery({
    queryKey: ["allRole"],
    queryFn: getAllRoles,
  });
};
